/* SIWS CUSTOM: Cart page Save & Get Help — cart-save-help.js
   Button opens a modal form; on submit POSTs to Google Apps Script webhook. */

// SIWS CUSTOM: Edit Bundle Order — event delegation handles button injected by Liquid/JS.
document.addEventListener('click', function (e) {
  if (e.target && e.target.id === 'cart-edit-order-btn') {
    e.preventDefault();
    if (confirm(
      'This will clear your cart and return you to the bundle page. Continue?'
    )) {
      const bundleUrl = e.target.dataset.bundleUrl || '/';
      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => { window.location.href = bundleUrl; })
        .catch(() => { window.location.href = bundleUrl; });
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('cart-save-help-btn');
  if (!btn) return;

  // SIWS CUSTOM: Inject modal into body once on page load.
  const modal = document.createElement('div');
  modal.id = 'siws-help-modal';
  modal.style.cssText = [
    'display:none',
    'position:fixed',
    'inset:0',
    'background:rgba(0,0,0,0.5)',
    'z-index:9999',
    'align-items:center',
    'justify-content:center',
    'padding:24px',
    'box-sizing:border-box',
  ].join(';');

  modal.innerHTML = [
    '<div style="background:#fff;max-width:480px;width:100%;padding:32px;border-radius:16px;',
    'max-height:90vh;overflow-y:auto;box-sizing:border-box;">',

    '<h2 style="margin:0 0 24px;font-size:1.25rem;font-weight:700;line-height:1.3;">',
    'Get Help from SIWS</h2>',

    '<div style="margin-bottom:16px;">',
    '<label style="display:block;font-size:0.875em;font-weight:600;margin-bottom:6px;">',
    'Dealer Name <span style="color:#dc2626;">*</span></label>',
    '<input id="siws-help-name" type="text" placeholder="Your name"',
    ' style="width:100%;box-sizing:border-box;border:1px solid #d1d5db;',
    'border-radius:8px;padding:10px 12px;font-size:1em;"></div>',

    '<div style="margin-bottom:16px;">',
    '<label style="display:block;font-size:0.875em;font-weight:600;margin-bottom:6px;">',
    'Phone Number <span style="color:#dc2626;">*</span></label>',
    '<input id="siws-help-phone" type="text" placeholder="Your phone number"',
    ' style="width:100%;box-sizing:border-box;border:1px solid #d1d5db;',
    'border-radius:8px;padding:10px 12px;font-size:1em;"></div>',

    '<div style="margin-bottom:16px;">',
    '<label style="display:block;font-size:0.875em;font-weight:600;margin-bottom:6px;">',
    'Dealer ID</label>',
    '<input id="siws-help-dealer-id" type="text" placeholder="Cornwell Dealer ID"',
    ' style="width:100%;box-sizing:border-box;border:1px solid #d1d5db;',
    'border-radius:8px;padding:10px 12px;font-size:1em;"></div>',

    '<div style="margin-bottom:24px;">',
    '<label style="display:block;font-size:0.875em;font-weight:600;margin-bottom:6px;">',
    'Message</label>',
    '<textarea id="siws-help-message" rows="4"',
    ' placeholder="What can we help you with?"',
    ' style="width:100%;box-sizing:border-box;border:1px solid #d1d5db;',
    'border-radius:8px;padding:10px 12px;font-size:1em;resize:vertical;"></textarea></div>',

    '<p id="siws-help-error"',
    ' style="display:none;color:#dc2626;font-size:0.875em;margin:0 0 12px;">',
    'Please fill in Dealer Name and Phone Number.</p>',

    '<button id="siws-help-submit" type="button"',
    ' style="width:100%;padding:14px;background:#111;color:#fff;border:none;',
    'border-radius:8px;font-size:1em;font-weight:600;cursor:pointer;margin-bottom:12px;">',
    'Send Help Request</button>',

    '<div style="text-align:center;">',
    '<a id="siws-help-cancel" href="#"',
    ' style="color:#6b7280;font-size:0.875em;text-decoration:none;">Cancel</a></div>',

    '</div>',
  ].join('');

  document.body.appendChild(modal);

  // --- helpers ---

  function openModal() {
    // Pre-fill Dealer ID from cart page input if present and filled
    var dealerIdInput = document.getElementById('siws-dealer-id');
    var helpDealerId  = document.getElementById('siws-help-dealer-id');
    if (dealerIdInput && helpDealerId && dealerIdInput.value.trim()) {
      helpDealerId.value = dealerIdInput.value.trim();
    }
    document.getElementById('siws-help-error').style.display = 'none';
    modal.style.display = 'flex';
    document.getElementById('siws-help-name').focus();
  }

  function closeModal() {
    modal.style.display = 'none';
  }

  // --- open on button click ---
  btn.addEventListener('click', openModal);

  // Close when clicking the dark overlay (not the card)
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.getElementById('siws-help-cancel').addEventListener('click', function (e) {
    e.preventDefault();
    closeModal();
  });

  // --- submit ---
  document.getElementById('siws-help-submit').addEventListener('click', function () {
    var name     = document.getElementById('siws-help-name').value.trim();
    var phone    = document.getElementById('siws-help-phone').value.trim();
    var dealerId = document.getElementById('siws-help-dealer-id').value.trim();
    var message  = document.getElementById('siws-help-message').value.trim();
    var errorEl  = document.getElementById('siws-help-error');

    if (!name || !phone) {
      errorEl.textContent = 'Please fill in Dealer Name and Phone Number.';
      errorEl.style.display = 'block';
      return;
    }
    errorEl.style.display = 'none';

    // SIWS CUSTOM: Webhook URL — Google Apps Script web app (handles cart_help_request type).
    var WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbxwOvGiEVl8x9bZM7-C2m7fA7pxr_-BEk3HIJeEo4VV9hyDrPq-LD7y9anJqjm6hq1Y-w/exec';

    var submitBtn = document.getElementById('siws-help-submit');
    submitBtn.disabled    = true;
    submitBtn.textContent = 'Sending\u2026';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // SIWS CUSTOM: Build cart permalink so M&C can reconstruct the dealer's exact cart.
        var cartUrl = 'https://cqtswag.com/cart/' + cart.items.map(function (item) {
          return item.variant_id + ':' + item.quantity;
        }).join(',');

        var payload = {
          type:         'cart_help_request',
          dealer_name:  name,
          dealer_phone: phone,
          dealer_id:    dealerId || '',
          message:      message  || '',
          cart_items:   cart.items,
          cart_total:   '$' + (cart.total_price / 100).toFixed(2),
          cart_url:     cartUrl,
          store_url:    'cqtswag.com',
        };

        // SIWS CUSTOM: mode:no-cors avoids preflight; Apps Script reads e.postData.contents fine.
        return fetch(WEBHOOK_URL, {
          method:  'POST',
          mode:    'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body:    JSON.stringify(payload),
        });
      })
      .then(function () {
        closeModal();
        var confirmEl = document.getElementById('cart-save-confirm');
        if (confirmEl) confirmEl.style.display = 'block';
        btn.textContent = 'Order Saved \u2713';
        btn.disabled    = true;
      })
      .catch(function () {
        submitBtn.disabled    = false;
        submitBtn.textContent = 'Send Help Request';
        errorEl.textContent   = 'Something went wrong \u2014 please email sayitwithswagllc@gmail.com for assistance.';
        errorEl.style.display = 'block';
      });
  });
});
